import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { trackEventLog } from '../../../core/utils'

import s from './index.css'
import RecommendCard from '../../common/RecommendCard'
import CourseCard from '../../common/CourseCard'
import Slide from '../../common/Slide'

class HeadArea extends React.Component {

  static propTypes = {
    head: PropTypes.array.isRequired,
    popularCourses: PropTypes.array.isRequired,
    discover: PropTypes.array.isRequired,
  }

  static defaultProps = {
    serialCourse: [],
  }

  render() {
    const { head, popularCourses, discover } = this.props
    return (
      <div className={s.root}>
        <div className={s.inner}>
          <Slide banners={head} inLocPrefix={'fp_h_'} />
          <div className={s.courses}>
            <h3 className={s.title}>热门课程</h3>
            <div>
              {popularCourses.map((course, inx) => (
                <CourseCard
                  topReco
                  key={`home-slide-course-${course.id}`}
                  data={course}
                  inLoc="web_home_popular"
                  onClick={() => { trackEventLog(`w/index/talk/${inx}`) }}
                />),
              )}
            </div>
            <h3 className={s.title2}>发现好课</h3>
            <div className={s.recommendContainer}>
              {discover.slice(0, 3).map((course, inx) => (
                <RecommendCard
                  inx={inx}
                  key={`discover-${inx}`}
                  data={course}
                  inLoc="web_home_explore"
                />),
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(HeadArea);



// WEBPACK FOOTER //
// ./src/components/p_home/SlideArea/index.js